import { render, staticRenderFns } from "./KeyboardKey.vue?vue&type=template&id=3d2ce3e5&scoped=true"
import script from "./KeyboardKey.vue?vue&type=script&lang=js"
export * from "./KeyboardKey.vue?vue&type=script&lang=js"
import style0 from "./KeyboardKey.vue?vue&type=style&index=0&id=3d2ce3e5&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2ce3e5",
  null
  
)

export default component.exports